import React from "react";
import PropTypes from "prop-types";

import { markerDeps } from "./utils.js";

const Defs = (props) => {
  let height = props.height;
  let width = props.width;

  return (
    <defs>
      {markerDeps.map(({ id, color }, index) => (
        <marker
          id={`arrow${id}`}
          viewBox="0 0 20 20"
          refX="5"
          refY="5"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
          fill={color}
          key={index}
        >
          <path d="M 0 0 L 10 5 L 0 10 z" />
        </marker>
      ))}
      {markerDeps.map(({ id, color }, index) => (
        <marker
          id={`block${id}`}
          refX="0"
          refY="5"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
          key={index}
        >
          <line x1="0" y1="10" x2="0" y2="0" strokeWidth={2} stroke={color} />
        </marker>
      ))}
      <mask id="maskIsLandscape">
        <rect x={0} y={0} width={width} height={height} fill="#fff" />
      </mask>
      <mask id="maskIsNotLandscape">
        <rect x={0} y={0} width={height} height={width} fill="#fff" />
      </mask>
    </defs>
  );
};

Defs.defaultProps = {
  fullPitchView: true,
  height: 0,
  isLandscape: true,
  width: 0
};

Defs.propTypes = {
  fullPitchView: PropTypes.bool,
  height: PropTypes.number,
  isLandscape: PropTypes.bool,
  width: PropTypes.number
};

export default Defs;
